import { render } from "./TabInner.vue?vue&type=template&id=154fa43c"
import script from "./TabInner.vue?vue&type=script&lang=js"
export * from "./TabInner.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/TabInner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "154fa43c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('154fa43c', __exports__)) {
    console.log('reload')
    api.reload('154fa43c', __exports__)
  }
  
  module.hot.accept("./TabInner.vue?vue&type=template&id=154fa43c", () => {
    console.log('re-render')
    api.rerender('154fa43c', render)
  })

}


export default __exports__